export enum ModalType {
  NO_HEADER = 'no-header',
  DEFAULT = 'default'
}

export interface ModalProps {
  title?: string
  canCloseByXBtn?: boolean
  fullscreen?: boolean
  type?: ModalType
  show?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose?: () => any
  canCloseByOverlay?: boolean
}
